var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidecart-wrapper" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.sidecartOpen
          ? _c("div", {
              staticClass: "sidecart__overlay",
              on: {
                click: function ($event) {
                  return _vm.$store.dispatch("cart/closeSidecart")
                },
              },
            })
          : _vm._e(),
      ]),
      _c("transition", { attrs: { name: "off-canvas-right" } }, [
        _vm.sidecartOpen
          ? _c("div", { staticClass: "sidecart" }, [
              _c(
                "div",
                { staticClass: "sidecart__main", class: _vm.emptyClass },
                [
                  _c(
                    "div",
                    { staticClass: "sidecart__header" },
                    [
                      _c("h2", { staticClass: "sidecart__title" }, [
                        _vm._v(
                          "Review Your Bag (" + _vm._s(_vm.totalItems) + ")"
                        ),
                      ]),
                      _c("icon-button", {
                        staticClass: "sidecart__close",
                        attrs: {
                          icon: "icon-close",
                          size: "20px",
                          label: "Close side cart",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$store.dispatch("cart/closeSidecart")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "sidecart__container" }, [
                    _vm.totalItems > 0
                      ? _c(
                          "div",
                          {
                            key: "content",
                            staticClass: "sidecart__contents-wrapper",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "sidecart__contents items-wrapper",
                                style: _vm.heightAutoStyle,
                              },
                              [
                                _c(
                                  "transition-group",
                                  { attrs: { name: "slide-fade-down" } },
                                  _vm._l(_vm.items, function (item, index) {
                                    return _c("sidecart-line-item", {
                                      key: item.id,
                                      attrs: {
                                        item: item,
                                        line: index + 1,
                                        order: _vm.items.length - index,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm.totalDiscount > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "sidecart__discount-summary",
                                      },
                                      [
                                        _vm._v(
                                          "Total Discount: " +
                                            _vm._s(
                                              _vm._f("money")(_vm.totalDiscount)
                                            )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sidecart__discount__wrapper",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "sidecart__discount__wrapper__block shippingContainer",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "sidecart__footer",
                                class: _vm.iOSDevice,
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "sidecart__subtotal" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "sidecart__subtotal--inner",
                                      },
                                      [
                                        _c("p", { staticClass: "p-s" }, [
                                          _vm._v("Subtotal "),
                                        ]),
                                        _c("p", { staticClass: "p-s" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("money")(_vm.totalPrice)
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "caption-s sidecart__subtotal--caption",
                                      },
                                      [
                                        _vm._v(
                                          "Shipping and taxes calculated at checkout"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "sidecart__checkout" },
                                  [
                                    _c("link-button", {
                                      staticClass:
                                        "sidecart__view-cart btn btn-transparent",
                                      attrs: {
                                        href: "/cart",
                                        label: "View Cart",
                                      },
                                    }),
                                    _c("checkout-link-button", {
                                      staticClass: "sidecart__checkout-cta btn",
                                      attrs: {
                                        href: "/checkout",
                                        label: "Checkout",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm.$mq === "mobile"
                              ? _c("div", {
                                  staticClass: "sidecart__footer-mobile-gap",
                                  class: _vm.iOSDevice,
                                })
                              : _vm._e(),
                          ]
                        )
                      : _c(
                          "div",
                          { key: "empty", staticClass: "sidecart__empty" },
                          [
                            _c(
                              "div",
                              { staticClass: "sidecart__empty__container" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "sidecart__empty__message p-m-m",
                                  },
                                  [_vm._v(_vm._s(_vm.emptyText))]
                                ),
                                _c(
                                  "ul",
                                  {
                                    staticClass: "sidecart__empty__collections",
                                  },
                                  _vm._l(_vm.collectionList, function (cta) {
                                    return cta.label.length > 0
                                      ? _c("link-button-image", {
                                          key: cta.label,
                                          staticClass: "button--hollow",
                                          attrs: {
                                            href: cta.collection,
                                            src: cta.image,
                                            label: cta.label,
                                          },
                                        })
                                      : _vm._e()
                                  }),
                                  1
                                ),
                              ]
                            ),
                            _vm.emptyCartCta === "ctas"
                              ? _c(
                                  "div",
                                  { staticClass: "sidecart__empty-buttons" },
                                  _vm._l(_vm.ctas, function (cta) {
                                    return cta.link.length > 0
                                      ? _c("link-button", {
                                          key: cta.link,
                                          staticClass: "button--hollow",
                                          attrs: {
                                            href: cta.link,
                                            label: cta.text,
                                          },
                                        })
                                      : _vm._e()
                                  }),
                                  1
                                )
                              : _c("gift-with-purchase-promo", {
                                  staticClass: "sidecart__empty-gwp",
                                }),
                          ],
                          1
                        ),
                  ]),
                ]
              ),
              _vm.totalItems === 0 && _vm.showRelatedProducts()
                ? _c(
                    "div",
                    { staticClass: "sidecart__main related__products" },
                    [
                      _c("div", { staticClass: "sidecart__related" }, [
                        _c("p", { staticClass: "sidecart__related__title" }, [
                          _vm._v("You May Also Like "),
                        ]),
                        _c(
                          "div",
                          { staticClass: "sidecart__related__arrows" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "sidecart__related__arrows--left",
                                on: {
                                  click: function ($event) {
                                    return _vm.previous()
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "42",
                                      height: "42",
                                      viewBox: "0 0 42 42",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        r: "21",
                                        transform: "matrix(-1 0 0 1 21 21)",
                                        fill: "#3D3D3D",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "m24 28-7-7 7-7",
                                        stroke: "#fff",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "sidecart__related__arrows--right",
                                on: {
                                  click: function ($event) {
                                    return _vm.next()
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "42",
                                      height: "42",
                                      viewBox: "0 0 42 42",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "21",
                                        cy: "21",
                                        r: "21",
                                        fill: "#3D3D3D",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "m18 28 7-7-7-7",
                                        stroke: "#fff",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "sidecart__productList" },
                        [
                          _c(
                            "flickity",
                            {
                              ref: "flickity",
                              attrs: { options: _vm.flickityOptions },
                            },
                            _vm._l(
                              _vm.shuffleProducts(),
                              function (item, index) {
                                return _vm.checkElement(item.variant_id, item)
                                  ? _c("sidecart-related-item", {
                                      directives: [
                                        {
                                          name: "images-loaded",
                                          rawName: "v-images-loaded",
                                          value: _vm.imgsLoaded,
                                          expression: "imgsLoaded",
                                        },
                                      ],
                                      key: item.id,
                                      attrs: { item: item },
                                    })
                                  : _vm._e()
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn sidecart__continue-shopping",
                          on: {
                            click: function ($event) {
                              return _vm.$store.dispatch("cart/closeSidecart")
                            },
                          },
                        },
                        [_vm._v("Continue Shopping")]
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }